export { PlaceSocials } from './PlaceSocials'
